module.exports = __webpack_public_path__ + "img/chat-page.40138049.jpg";